/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RequestAuditPerformanceCounter {
    getFixupPrototypeFunction() { return RequestAuditPerformanceCounter.fixupPrototype; }

    static newInstance(model: Partial<RequestAuditPerformanceCounter>): RequestAuditPerformanceCounter {
        let obj = Object.assign(new RequestAuditPerformanceCounter(), model);
        RequestAuditPerformanceCounter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RequestAuditPerformanceCounter>): RequestAuditPerformanceCounter {
        if (!model) return null;
        return RequestAuditPerformanceCounter.newInstance(<RequestAuditPerformanceCounter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RequestAuditPerformanceCounter) {
        if (!obj) return;

        models.RequestAuditPerformanceCounter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RequestAuditPerformanceCounter): boolean {
        Object.setPrototypeOf(obj, RequestAuditPerformanceCounter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.count === undefined) {
            this.count = 0;
        }
        if (this.execution_time === undefined) {
            this.execution_time = 0;
        }
        if (this.wait_time === undefined) {
            this.wait_time = 0;
        }
    }

    /**
     * Number of events.
     */
    count: number;

    /**
     * Execution time in seconds.
     */
    execution_time: number;

    /**
     * Lock contention time in seconds.
     */
    wait_time: number;

}
